import { render, staticRenderFns } from "./app-embed.vue?vue&type=template&id=53490ef2&"
import script from "./app-embed.vue?vue&type=script&lang=js&"
export * from "./app-embed.vue?vue&type=script&lang=js&"
import style0 from "./app-embed.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./app-embed.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports